export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETECH_ALL';
export const LOGOUT = 'LOGOUT';
export const AUTH = 'AUTH';
export const COMMENT = 'COMMENT';
export const USERS = 'USERS';